import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export default function ActivityMarket({activity}) {
    const { t } = useTranslation()
    const imageUrl = activity?.image || `/images/sports/${activity?.sport}.jpg`
    const [sportIconError, setSportIconError] = useState(false)

    const sportIconPath = `/images/sports/iconos/${activity?.sport}.svg`

    return (
        <div className="activity-card">
            <Link to={`/${t("url.marketplace.clubs")}/${activity?.club?.url}/${t("url.marketplace.activities")}/${activity?.url}`} className="activity-card-image-link">
                <div className="activity-card-image" style={{backgroundImage: `url(${imageUrl})`}}>
                </div>
            </Link>
            <div className="activity-card-body">
                <div className="activity-card-tags">
                    <span className="activity-card-tag sport">
                        {!sportIconError
                            ? <img src={sportIconPath} alt="" onError={() => setSportIconError(true)} />
                            : <i className="fas fa-running" style={{fontSize: 10}}></i>
                        }
                        {t('sports.' + (activity?.sport || ''))}
                    </span>
                </div>
                <Link to={`/${t("url.marketplace.clubs")}/${activity?.club?.url}/${t("url.marketplace.activities")}/${activity?.url}`} className="activity-card-title-link">
                    <h3 className="activity-card-title">{activity.title}</h3>
                </Link>
                <div className="activity-card-meta">
                    <span className="activity-card-club">
                        <i className="fas fa-building"></i>
                        {activity?.club?.name}
                    </span>
                </div>
                <div className="activity-card-footer">
                    <span className="activity-card-price">
                        {activity?.minimumPrice !== 0
                            ? <>{t("global.from")} <strong>{activity?.minimumPrice?.toFixed(2)}€</strong></>
                            : <span className="free-text">{t("activities.free")}</span>
                        }
                    </span>
                    <Link to={`/${t("url.marketplace.clubs")}/${activity?.club?.url}/${t("url.marketplace.activities")}/${activity?.url}`} className="activity-card-btn">
                        {t("activities.enrole")}
                        <i className="fas fa-arrow-right"></i>
                    </Link>
                </div>
            </div>
        </div>
    )
}
